import { render, staticRenderFns } from "./appealReview.vue?vue&type=template&id=f95c307e&scoped=true&"
import script from "./appealReview.vue?vue&type=script&lang=js&"
export * from "./appealReview.vue?vue&type=script&lang=js&"
import style0 from "./appealReview.vue?vue&type=style&index=0&id=f95c307e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95c307e",
  null
  
)

export default component.exports